import React, { useState } from 'react';
import './FeaturesInteractive.css';
import rewardsImage from '../assets/rewards.jpeg';
import notificationsImage from '../assets/notification.jpeg';
import engagementImage from '../assets/insight.jpeg';

const FEATURES = [
  {
    id: 'rewards',
    title: 'Run a rewards program',
    body: "Set up custom rewards in three taps. Free drinks, BOGO, percentage off — you decide what makes sense for your shop. Customers tap their phone at the kiosk, stamps stack automatically.",
    image: rewardsImage,
    alt: 'Dangol rewards screen on a phone',
  },
  {
    id: 'notifications',
    title: 'Send notifications that land',
    body: "Push straight to your regulars' lock screens, scheduled for the moments they'll act — the morning rush, the slow Tuesday, the rainy Thursday you'd love to fill.",
    image: notificationsImage,
    alt: 'Dangol notifications screen on a phone',
  },
  {
    id: 'engagement',
    title: 'Keep your regulars close',
    body: "See who's coming back, who's slipping away, and who's about to become a regular. Dangol shows you the relationships that matter.",
    image: engagementImage,
    alt: 'Dangol customer engagement screen on a phone',
  },
];

const FeaturesInteractive = () => {
  const [activeId, setActiveId] = useState(FEATURES[0].id);
  const active = FEATURES.find((f) => f.id === activeId);

  return (
    <section id="features" className="features-interactive">

      <div className="features-interactive-intro container-narrow reveal">
        <span className="eyebrow">See it in action</span>
        <h2 className="features-interactive-headline display">
          Every tool you need,<br />
          <em>in your pocket.</em>
        </h2>
      </div>

      <div className="features-interactive-grid">

        {/* Left: clickable feature list */}
        <div className="features-interactive-list reveal">
          {FEATURES.map((feature) => {
            const isActive = feature.id === activeId;
            return (
              <button
                key={feature.id}
                className={`feature-row ${isActive ? 'feature-row--active' : ''}`}
                onClick={() => setActiveId(feature.id)}
                aria-expanded={isActive}
              >
                <div className="feature-row-header">
                  <h3 className="feature-row-title display">{feature.title}</h3>
                  <span className="feature-row-toggle" aria-hidden="true">
                    {isActive ? '−' : '+'}
                  </span>
                </div>
                <div className={`feature-row-body ${isActive ? 'feature-row-body--open' : ''}`}>
                  <p>{feature.body}</p>
                  {/* Mobile-only inline image — appears inside the expanded row */}
                  <div className="feature-row-image-mobile">
                    <img
                      src={feature.image}
                      alt={feature.alt}
                      className="feature-screen-image"
                    />
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        {/* Right: animated screen — desktop only */}
        <div className="features-interactive-screen reveal reveal-delay-1">
          <img
            key={active.id}
            src={active.image}
            alt={active.alt}
            className="feature-screen-image"
          />
        </div>

      </div>

    </section>
  );
};

export default FeaturesInteractive;
